<template>
	<a-drawer title="Todos los resúmenes" placement="right" :closable="true" :open="opened" width="480px" @close="opened = false">
		<div class="d-flex flex-row justify-content-between align-items-center  mb-3">
			<div class="text-uppercase font-size-12 text-gray-6 px-2 pt-2">
				<b>Resultados:</b> ({{ summaries.total }})
			</div>

			<div class="div">
				<a-tooltip placement="top">
					<template #title>
						<span>Refrescar</span>
					</template>
					<a class="pointer" @click="list()">
						<fa-icon :icon="['fal', 'sync']" :spin="summaries.loading" />
					</a>
				</a-tooltip>
			</div>
		</div>

		<a v-for="s in summaries.results" :key="s.id" :class="[$style.item]" class="d-flex flex-nowrap align-items-center" @click="openSummary(s.id)">
			<a-avatar shape="square" :size="50" class="mr-2"><template #icon><a-icon type="user" /></template></a-avatar>
			<div :class="$style.info" class="flex-grow-1">
				<div class="text-uppercase font-size-12 text-truncate text-gray-6">
					<a-tooltip placement="top">
						<template #title>
							<span>{{ $moment(s.created_at).format('LLL') }}</span>
						</template>

						<b v-if="$moment().diff(s.created_at) > 0" class="text-uppercase text-muted mr-auto">{{ $moment(s.created_at).fromNow() }}</b>
						<b v-else class="text-uppercase text-danger mr-auto"><fa-icon :icon="['far','alarm-clock']" class="mr-2 animated pulse delay-1s infinite" />{{ $moment(s.created_at).fromNow() }}</b>
					</a-tooltip>
				</div>
				<div class="text-dark font-size-18 font-weight-bold text-truncate">
					#{{ s.id }}
				</div>
			</div>
			<div class="flex-shrink-0 align-self-start">
				<div class="air__utils__avatarGroup" :class="[s.deals.length ? '' : 'd-none']">
					<a-tooltip v-for="(d,u) in s.deals" :key="u" placement="top">
						<template #title>
							<span>{{ d.name }}</span>
						</template>

						<div class="air__utils__avatar air__utils__avatar--rounded">
							<img :src="images().deal(d,100)" :alt="d.name">
						</div>
					</a-tooltip>
				</div>
			</div>
		</a>

		<infinite-loading :distance="800" @infinite="list($event, false)">
			<template #spinner>
				<div>
					<ghost-message animated="pulse" infinite :icon="['fad','heartbeat']" :text="'Cargando resultados'" />
				</div>
			</template>
			<template #no-results>
				<div>
					<ghost-message animated="tada" infinite :icon="['fad','ghost']" :text="'Sin resultados'" />
				</div>
			</template>
			<template #no-more>
				<div>
					<ghost-message animated="tada" :icon="['fad','ghost']" :text="'No hay más resultados'" />
				</div>
			</template>
		</infinite-loading>
	</a-drawer>
</template>

<script>
import InfiniteLoading from 'v3-infinite-loading';

export default {
	name: 'Summaries',
	components: {
		InfiniteLoading,
	},
	data() {
		return {
			opened: false,
		};
	},
	computed: {
		summaries() {
			return this.$store.getters['data/summaries'];
		},
	},
	created() {
		const self = this;
		this.$hub.on('listSummaries', () => {
			self.opened = true;
		});
	},
	unmounted() {
		this.$hub.off('listSummaries');
	},
	methods: {
		async list($state = null, reset = true) {
			const result = await this.$store.dispatch('summaries/list', reset);
			if (result.state === 'loaded' && $state) { $state.loaded(); } else if ($state) { $state.complete(); }
		},
		openSummary(id) {
			this.opened = false;
			this.$router.push({ name: 'summaryEdit', params: { id } });
		},
	},
};
</script>

<style lang="scss" module>
	@import "./style.module.scss";
</style>
